module.exports = __webpack_public_path__ + "img/reviewLog.487ec88b.png";